import { render, staticRenderFns } from "./InsuranceProfile.vue?vue&type=template&id=08f7b991"
import script from "./InsuranceProfile.vue?vue&type=script&lang=js"
export * from "./InsuranceProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports